/**
 * Packaging2Go Theme JavaScript
 * Handles: Announcement bar rotation, header scroll, search drawer,
 * mobile nav with accordion, cart drawer, product page, quantity selectors
 */

(function () {
  'use strict';

  // ---- Announcement Bar Auto-Rotate ----
  const announcementSlides = document.querySelectorAll('[data-announcement-slide]');
  if (announcementSlides.length > 1) {
    let currentSlide = 0;
    setInterval(function () {
      announcementSlides[currentSlide].classList.remove('is-active');
      currentSlide = (currentSlide + 1) % announcementSlides.length;
      announcementSlides[currentSlide].classList.add('is-active');
    }, 5000);
  }

  // ---- Header Scroll Effect ----
  const header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // ---- Search Drawer ----
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');

  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      searchDrawer.classList.toggle('is-open');
      if (searchDrawer.classList.contains('is-open') && searchInput) {
        setTimeout(function () { searchInput.focus(); }, 100);
      }
    });
  }

  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', function () {
      searchDrawer.classList.remove('is-open');
    });
  }

  // ---- Mobile Navigation ----
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  function openMobileMenu() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ---- Mobile Accordion ----
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      this.classList.toggle('is-open');
      var content = this.nextElementSibling || document.querySelector('[data-accordion-content]');
      if (content) {
        content.classList.toggle('is-open');
      }
    });
  });

  // ---- Cart Drawer ----
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var cartDrawerClose = document.querySelector('[data-cart-drawer-close]');

  function openCartDrawer(e) {
    if (e) e.preventDefault();
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  // ---- Quantity Selectors ----
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quantity-minus]')) {
      var input = e.target.closest('.quantity-selector').querySelector('[data-quantity-input], .quantity-selector__input');
      if (input) {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      }
    }

    if (e.target.closest('[data-quantity-plus]')) {
      var input = e.target.closest('.quantity-selector').querySelector('[data-quantity-input], .quantity-selector__input');
      if (input) {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      }
    }
  });

  // ---- Product Page: Thumbnail Gallery ----
  document.querySelectorAll('[data-thumbnail]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('product-main-img');
      var imageUrl = this.getAttribute('data-image-url');
      if (mainImg && imageUrl) {
        mainImg.src = imageUrl;
        document.querySelectorAll('[data-thumbnail]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      }
    });
  });

  // Auto-select image from ?image=N param (when coming from product card thumbnail)
  (function () {
    var params = new URLSearchParams(window.location.search);
    var imageParam = params.get('image');
    if (imageParam) {
      var idx = parseInt(imageParam) - 1;
      var thumbs = document.querySelectorAll('[data-thumbnail]');
      if (thumbs[idx]) {
        thumbs[idx].click();
      }
    }
  })();

  // ---- Product Card: Thumbnail image switcher ----
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-product]');
    if (!thumb) return;
    e.preventDefault();

    var newSrc = thumb.getAttribute('data-thumb-src');

    // Find the main image within THIS specific card (not globally by product ID)
    var card = thumb.closest('.product-card');
    if (!card) return;

    var mainImg = card.querySelector('[data-product-main-image]');
    if (mainImg && newSrc) {
      mainImg.src = newSrc;
    }

    // Update active state on thumbnails within this card only
    var allThumbs = card.querySelectorAll('.product-card__thumb');
    var thumbIndex = 0;
    allThumbs.forEach(function (t, i) {
      t.classList.remove('is-active');
      if (t === thumb) thumbIndex = i;
    });
    thumb.classList.add('is-active');

    // Update "Choose Options" link with selected image index
    var chooseLink = card.querySelector('.product-card__atc-btn[href]');
    if (chooseLink) {
      var baseUrl = chooseLink.getAttribute('href').split('?')[0];
      chooseLink.setAttribute('href', baseUrl + '?image=' + (thumbIndex + 1));
    }
  });

 // ---- Product Page: Variant Selection (buttons + table rows) ----
var variantOptions = document.querySelectorAll('[data-variant-option]');
var variantSelect = document.querySelector('[data-variant-select]');

if (variantOptions.length && variantSelect) {
  var variantGroups = Array.from(document.querySelectorAll('.product__variant-group'));
  var shopifyVariants = [];

  // Keep every Shopify variant in the picker. Purchasing availability is a
  // separate state: it must never make an existing option combination vanish.
  variantSelect.querySelectorAll('option').forEach(function(option) {
    shopifyVariants.push({
      id: option.value,
     values: [
  option.getAttribute('data-option-1'),
  option.getAttribute('data-option-2'),
  option.getAttribute('data-option-3')
].map(function(value) {
  return value ? value.replace(/["″]\s*$/, '').trim() : value;
}),
      available: option.getAttribute('data-variant-available') === 'true',
      sku: option.getAttribute('data-variant-sku') || '',
      casePack: option.getAttribute('data-variant-case-pack') || '',
      option: option
    });
  });

  function getSelectedOptions() {
    return variantGroups.map(function(group) {
      var selected = group.querySelector('[data-variant-option].is-selected');
      return selected ? selected.getAttribute('data-option-value') : null;
    });
  }

  // Checks existence only. Zero inventory does not affect this result.
  function variantExists(testValues) {
    return shopifyVariants.some(function(variant) {
      return testValues.every(function(value, index) {
        return value === null || variant.values[index] === value;
      });
    });
  }

  function findMatchingVariant(selectedValues) {
    return shopifyVariants.find(function(variant) {
      return selectedValues.every(function(value, index) {
        return value === null || variant.values[index] === value;
      });
    }) || null;
  }

  // When a changed option invalidates a later choice, use a real Shopify
  // variant and retain as many of those later selections as possible.
  function findBestVariant(selectedValues, changedIndex) {
    var candidates = shopifyVariants.filter(function(variant) {
      for (var i = 0; i <= changedIndex; i++) {
        if (selectedValues[i] !== null && variant.values[i] !== selectedValues[i]) return false;
      }
      return true;
    });

    return candidates.reduce(function(best, candidate) {
      if (!best) return candidate;
      var candidateScore = 0;
      var bestScore = 0;
      for (var i = changedIndex + 1; i < selectedValues.length; i++) {
        if (candidate.values[i] === selectedValues[i]) candidateScore++;
        if (best.values[i] === selectedValues[i]) bestScore++;
      }
      return candidateScore > bestScore ? candidate : best;
    }, null);
  }

  function syncSelectedOptionControls(values) {
    variantGroups.forEach(function(group, groupIndex) {
      group.querySelectorAll('[data-variant-option]').forEach(function(control) {
        control.classList.toggle('is-selected', control.getAttribute('data-option-value') === values[groupIndex]);
      });
      var selectedLabel = group.querySelector('[data-selected-option]');
      if (selectedLabel) selectedLabel.textContent = values[groupIndex] || '';
    });
  }

  function updateAvailableOptions() {
    var selected = getSelectedOptions();

    variantGroups.forEach(function(group, groupIndex) {
      group.querySelectorAll('[data-variant-option]').forEach(function(control) {
        var testValues = selected.map(function(value, index) {
          return index < groupIndex ? value : null;
        });
        testValues[groupIndex] = control.getAttribute('data-option-value');
        var exists = variantExists(testValues);

        control.disabled = !exists;
        control.classList.toggle('is-unavailable', !exists);
        control.setAttribute('aria-disabled', exists ? 'false' : 'true');
      });
    });
  }

  function updateSelectedVariantState(variant) {
    var sku = document.querySelector('[data-variant-sku]');
    var casePack = document.querySelector('[data-variant-case-pack]');
    var availability = document.querySelector('[data-variant-availability]');
    var addToCart = document.querySelector('[data-add-to-cart]');

    if (sku) sku.textContent = variant.sku || '-';
    if (casePack) casePack.textContent = variant.casePack || '-';
    if (availability) availability.hidden = variant.available;
    if (addToCart) {
      addToCart.disabled = !variant.available;
      addToCart.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  function updateVariantFromOptions(changedIndex) {
    var selectedOptions = getSelectedOptions();
    var matchingVariant = findMatchingVariant(selectedOptions);

    if (!matchingVariant && typeof changedIndex === 'number') {
      matchingVariant = findBestVariant(selectedOptions, changedIndex);
    }
    if (!matchingVariant) return;

    syncSelectedOptionControls(matchingVariant.values);
    variantSelect.value = matchingVariant.id;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    updateSelectedVariantState(matchingVariant);
    updateAvailableOptions();
  }

  variantOptions.forEach(function(control) {
    control.addEventListener('click', function(event) {
      if (this.disabled) {
        event.preventDefault();
        return;
      }

      var group = this.closest('.product__variant-group');
      if (!group) return;
      var groupIndex = variantGroups.indexOf(group);
      var selectedOptions = getSelectedOptions();
      selectedOptions[groupIndex] = this.getAttribute('data-option-value');

      syncSelectedOptionControls(selectedOptions);
      updateVariantFromOptions(groupIndex);
    });
  });

  updateVariantFromOptions();
}
// ---- Sort Select (Collection Page) ----
  // ---- Sort Select (Collection Page) ----
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ---- Collection Filter Form ----
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      // Collect all checked checkboxes
      filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      // Collect price range inputs
      filterForm.querySelectorAll('input[type="number"]').forEach(function (inp) {
        if (inp.value && inp.value !== '0') {
          // Shopify expects price in cents for filter URLs
          params.set(inp.name, (parseFloat(inp.value) * 100).toString());
        }
      });
      // Preserve sort
      var sortVal = document.querySelector('[data-sort-select]');
      if (sortVal && sortVal.value) {
        params.set('sort_by', sortVal.value);
      }
      var basePath = window.location.pathname;
      var qs = params.toString();
      window.location.href = basePath + (qs ? '?' + qs : '');
    });

    // Auto-submit on checkbox change (instant filtering)
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        filterForm.dispatchEvent(new Event('submit'));
      });
    });
  }

  // Filter group toggle (collapse/expand)
  document.querySelectorAll('[data-filter-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      this.classList.toggle('is-collapsed');
      var options = this.nextElementSibling;
      if (options) {
        options.style.display = options.style.display === 'none' ? '' : 'none';
      }
    });
  });

  // ---- Cart AJAX (No Page Refresh) ----
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'GBP'
    });
  }

  function removeCartItemEl(key) {
    document.querySelectorAll('[data-cart-item-key="' + key + '"]').forEach(function (el) {
      el.style.transition = 'opacity 0.3s, transform 0.3s';
      el.style.opacity = '0';
      el.style.transform = 'translateX(-20px)';
      setTimeout(function () { el.remove(); }, 300);
    });
  }

  function updateCartTotals(cart) {
    var itemCount = cart.item_count;
    var hasDiscount = cart.original_total_price !== cart.total_price;

    // Header + drawer counts
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCount;
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (el) {
      el.textContent = itemCount;
    });

    // Cart page summary
    document.querySelectorAll('[data-cart-discounts]').forEach(function (el) {
      el.style.display = hasDiscount ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-original]').forEach(function (el) {
      el.textContent = formatMoney(cart.original_total_price);
    });
    document.querySelectorAll('[data-cart-savings]').forEach(function (el) {
      el.textContent = '-' + formatMoney(cart.original_total_price - cart.total_price);
    });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-cart-checkout-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    // Cart drawer summary
    document.querySelectorAll('[data-cart-drawer-discounts]').forEach(function (el) {
      el.style.display = hasDiscount ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-drawer-original]').forEach(function (el) {
      el.textContent = formatMoney(cart.original_total_price);
    });
    document.querySelectorAll('[data-cart-drawer-savings]').forEach(function (el) {
      el.textContent = '-' + formatMoney(cart.original_total_price - cart.total_price);
    });
    document.querySelectorAll('[data-cart-drawer-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-cart-drawer-footer]').forEach(function (el) {
      el.style.display = itemCount > 0 ? '' : 'none';
    });

    // Empty state
    if (itemCount === 0) {
      var cartContent = document.querySelector('[data-cart-content]');
      var cartEmpty = document.querySelector('[data-cart-empty]');
      if (cartContent) cartContent.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = '';

      var drawerItems = document.querySelector('[data-cart-drawer-items]');
      if (drawerItems) {
        drawerItems.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections" class="btn btn--primary" style="margin-top: 16px;">Shop Now</a></div>';
      }
    }
  }

  var cartDebounceTimers = {};

  function fetchAndUpdateCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin'
    })
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      if (cart && cart.items) {
        cart.items.forEach(function (item) {
          document.querySelectorAll('[data-cart-item-price="' + item.key + '"]').forEach(function (priceEl) {
            if (item.original_line_price !== item.final_line_price) {
              priceEl.innerHTML = '<span class="cart__item-price--original">' + formatMoney(item.original_line_price) + '</span>' +
                '<span class="cart__item-price--sale">' + formatMoney(item.final_line_price) + '</span>';
            } else {
              priceEl.textContent = formatMoney(item.final_line_price);
            }
          });
        });
        updateCartTotals(cart);
      }
      return cart;
    })
    .catch(function (err) {
      console.error('Cart fetch failed:', err);
    });
  }

  // Update all cart item DOM elements by index position (not key, since keys can change)
  function syncCartItemsDOM(cart) {
    // Get item containers from cart page and drawer
    var pageItems = document.querySelectorAll('[data-cart-page] [data-cart-item]');
    var drawerItems = document.querySelectorAll('[data-cart-drawer-items] [data-cart-item]');

    function updateItemEl(el, item) {
      if (!el || !item) return;

      // Update the item key attribute
      el.setAttribute('data-cart-item-key', item.key);

      // Update price element
      var priceEl = el.querySelector('.cart__item-price');
      if (priceEl) {
        priceEl.setAttribute('data-cart-item-price', item.key);
        if (item.original_line_price !== item.final_line_price) {
          priceEl.innerHTML = '<span class="cart__item-price--original">' + formatMoney(item.original_line_price) + '</span>' +
            '<span class="cart__item-price--sale">' + formatMoney(item.final_line_price) + '</span>';
        } else {
          priceEl.textContent = formatMoney(item.final_line_price);
        }
      }

      // Update quantity input
      var qtyInput = el.querySelector('.quantity-selector__input');
      if (qtyInput) {
        qtyInput.value = item.quantity;
        qtyInput.setAttribute('data-key', item.key);
      }

      // Update all data-key attributes (minus, plus, remove buttons)
      el.querySelectorAll('[data-key]').forEach(function (btn) {
        btn.setAttribute('data-key', item.key);
      });
    }

    cart.items.forEach(function (item, index) {
      updateItemEl(pageItems[index], item);
      updateItemEl(drawerItems[index], item);
    });

    updateCartTotals(cart);
  }

  function updateCartQuantity(key, quantity) {
    // If removing, animate out immediately
    if (quantity === 0) {
      removeCartItemEl(key);
    }

    // Debounce per item
    if (cartDebounceTimers[key]) {
      clearTimeout(cartDebounceTimers[key]);
    }

    cartDebounceTimers[key] = setTimeout(function () {
      delete cartDebounceTimers[key];

      // Use change.js with the full line item key
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            console.error('Cart change error:', response.status, text);
            throw new Error('Cart change failed');
          });
        }
        return response.json();
      })
      .then(function (cart) {
        if (cart && cart.items) {
          syncCartItemsDOM(cart);
        }
      })
      .catch(function (err) {
        console.error('Cart update failed:', err);
        fetchAndUpdateCart();
      });
    }, quantity === 0 ? 0 : 300);
  }

  document.addEventListener('click', function (e) {
    // Cart quantity minus
    if (e.target.closest('[data-cart-quantity-minus]')) {
      e.preventDefault();
      var btn = e.target.closest('[data-cart-quantity-minus]');
      var key = btn.getAttribute('data-key');
      var input = btn.closest('.quantity-selector').querySelector('.quantity-selector__input');
      if (input && key) {
        var val = parseInt(input.value) || 1;
        var newVal = Math.max(0, val - 1);
        input.value = newVal;
        updateCartQuantity(key, newVal);
      }
    }

    // Cart quantity plus
    if (e.target.closest('[data-cart-quantity-plus]')) {
      e.preventDefault();
      var btn = e.target.closest('[data-cart-quantity-plus]');
      var key = btn.getAttribute('data-key');
      var input = btn.closest('.quantity-selector').querySelector('.quantity-selector__input');
      if (input && key) {
        var val = parseInt(input.value) || 1;
        var newVal = val + 1;
        input.value = newVal;
        updateCartQuantity(key, newVal);
      }
    }

    // Cart item remove
    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      var key = e.target.closest('[data-cart-remove]').getAttribute('data-key');
      if (key) {
        updateCartQuantity(key, 0);
      }
    }
  });

  // Cart quantity input direct change
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-quantity-input]')) {
      var key = e.target.getAttribute('data-key');
      var val = parseInt(e.target.value) || 0;
      if (key) {
        updateCartQuantity(key, val);
      }
    }
  });

  // ---- AJAX Add to Cart (product cards) ----
  function buildCartItemHTML(item) {
    var priceHTML = formatMoney(item.final_line_price);
    var variantHTML = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variantHTML = '<p class="cart__item-variant">' + item.variant_title + '</p>';
    }
    var imgHTML = '';
    if (item.image) {
      imgHTML = '<a href="' + item.url + '"><img src="' + item.image + '" alt="" width="70" height="70" loading="lazy"></a>';
    }

    return '<div class="cart__item" style="grid-template-columns: 70px 1fr auto;" data-cart-item data-cart-item-key="' + item.key + '">' +
      '<div class="cart__item-image">' + imgHTML + '</div>' +
      '<div>' +
        '<h3 class="cart__item-title" style="font-size: 14px;"><a href="' + item.url + '">' + item.product_title + '</a></h3>' +
        variantHTML +
        '<div class="quantity-selector quantity-selector--sm" style="margin-top: 6px;">' +
          '<button type="button" class="quantity-selector__btn" data-cart-quantity-minus data-key="' + item.key + '" aria-label="Decrease quantity">-</button>' +
          '<input class="quantity-selector__input" type="number" value="' + item.quantity + '" min="0" data-cart-quantity-input data-key="' + item.key + '" aria-label="Quantity">' +
          '<button type="button" class="quantity-selector__btn" data-cart-quantity-plus data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart__item-price" style="font-size: 14px;" data-cart-item-price="' + item.key + '">' + priceHTML + '</div>' +
    '</div>';
  }

  // ---- Custom branding: show the chosen file name ----
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-branding-input]');
    if (!input) return;
    var label = input.parentNode.querySelector('[data-branding-filename]');
    if (!label) return;
    if (input.files && input.files.length > 0) {
      label.textContent = 'Selected: ' + input.files[0].name;
      label.hidden = false;
    } else {
      label.textContent = '';
      label.hidden = true;
    }
  });

  document.addEventListener('submit', function (e) {
    // Handle product card forms ([data-add-to-cart-form])
    var form = e.target.closest('[data-add-to-cart-form]');
    // Also handle product page form (has [data-add-to-cart] button)
    if (!form && e.target.querySelector('[data-add-to-cart]') && e.target.action && e.target.action.indexOf('/cart/add') !== -1) {
      form = e.target;
    }
    if (!form) return;

    // Custom-branding products include a file input. Shopify's AJAX cart API
    // (/cart/add.js) cannot accept file uploads, so when a non-empty file is
    // present we let the form submit natively (multipart POST -> /cart/add).
    var fileInput = form.querySelector('input[type="file"]');
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      return; // native submit; browser navigates to the cart page
    }

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]') || form.querySelector('[data-add-to-cart]');
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    var formData = new FormData(form);
    var data = {};
    formData.forEach(function (val, key) { data[key] = val; });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(data.id), quantity: parseInt(data.quantity) || 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function (addedItem) {
      // Get fresh cart to update totals
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Clear empty state if present
          var drawerItems = document.querySelector('[data-cart-drawer-items]');
          if (drawerItems) {
            var emptyMsg = drawerItems.querySelector('.cart-drawer__empty');
            if (emptyMsg) emptyMsg.remove();

            // Check if this item already exists in drawer (same key = quantity updated)
            var existingEl = drawerItems.querySelector('[data-cart-item-key="' + addedItem.key + '"]');
            if (existingEl) {
              // Update quantity input
              var qtyInput = existingEl.querySelector('.quantity-selector__input');
              if (qtyInput) qtyInput.value = addedItem.quantity;
            } else {
              // Append new item to drawer
              drawerItems.insertAdjacentHTML('beforeend', buildCartItemHTML(addedItem));
            }
          }

          // Show footer
          document.querySelectorAll('[data-cart-drawer-footer]').forEach(function (el) {
            el.style.display = '';
          });

          // Sync all totals
          syncCartItemsDOM(cart);

          // Open drawer
          openCartDrawer();
        });
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
    })
    .finally(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // ---- Close drawers on Escape ----
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
      if (searchDrawer) searchDrawer.classList.remove('is-open');
    }
  });

  // ---- FAQ Accordion ----
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-faq-toggle]');
    if (!toggle) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    var answer = toggle.nextElementSibling;

    // Close all other open FAQs in the same list
    var list = toggle.closest('.faq-page__list');
    if (list) {
      list.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach(function (btn) {
        if (btn !== toggle) {
          btn.setAttribute('aria-expanded', 'false');
          var ans = btn.nextElementSibling;
          if (ans) ans.classList.remove('is-open');
        }
      });
    }

    // Toggle current
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (answer) answer.classList.toggle('is-open', !isOpen);
  });

  // ---- Products Mega Menu ----
document.addEventListener('click', function (e) {

  var productsBtn = e.target.closest('[data-products-toggle]');

  // Clicked the Products button
  if (productsBtn) {
    e.preventDefault();
    e.stopPropagation();

    var wrap = productsBtn.closest('.header__products-wrap');
    if (!wrap) return;

    var megaMenu = wrap.querySelector('[data-mega-menu]');
    if (!megaMenu) return;

    var isOpen = megaMenu.classList.contains('is-open');

    // Close all Products menus first
    document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
      menu.classList.remove('is-open');
    });

    document.querySelectorAll('[data-products-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Open this one if it was closed
    if (!isOpen) {
      megaMenu.classList.add('is-open');
      productsBtn.setAttribute('aria-expanded', 'true');
    }

    return;
  }

  // Clicked inside the mega menu
  if (e.target.closest('[data-mega-menu]')) {
    return;
  }

  // Clicked elsewhere, close Products menu
  document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
    menu.classList.remove('is-open');
  });

  document.querySelectorAll('[data-products-toggle]').forEach(function (btn) {
    btn.setAttribute('aria-expanded', 'false');
  });

});


// ---- Mega Menu Category Hover ----
document.addEventListener('mouseenter', function (e) {

 var target = e.target;
if (!(target instanceof Element)) return;
var cat = target.closest('[data-mega-cat]');
  if (!cat) return;

  var index = cat.getAttribute('data-mega-cat');

  document.querySelectorAll('[data-mega-cat]').forEach(function (item) {
    item.classList.remove('is-active');
  });

  document.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
    panel.classList.remove('is-active');
  });

  document.querySelectorAll('[data-mega-promo]').forEach(function (promo) {
    promo.classList.remove('is-active');
  });

  cat.classList.add('is-active');

  var panel = document.querySelector(
    '[data-mega-panel="' + index + '"]'
  );

  if (panel) {
    panel.classList.add('is-active');
  }

  var promo = document.querySelector(
    '[data-mega-promo="' + index + '"]'
  );

  if (promo) {
    promo.classList.add('is-active');
  }

}, true);
  // ---- Collection Carousel Navigation ----
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');

    if (prev) {
      var trackId = prev.getAttribute('data-carousel-prev');
      var track = document.getElementById(trackId);
      if (track) {
        var itemWidth = track.querySelector('.use-case-row__item');
        var scrollAmount = itemWidth ? itemWidth.offsetWidth + 16 : 220;
        track.scrollBy({ left: -scrollAmount * 2, behavior: 'smooth' });
      }
    }

    if (next) {
      var trackId = next.getAttribute('data-carousel-next');
      var track = document.getElementById(trackId);
      if (track) {
        var itemWidth = track.querySelector('.use-case-row__item');
        var scrollAmount = itemWidth ? itemWidth.offsetWidth + 16 : 220;
        track.scrollBy({ left: scrollAmount * 2, behavior: 'smooth' });
      }
    }
  });

  // ---- Reviews Carousel Navigation ----
  document.addEventListener('click', function (e) {
    var reviewsPrev = e.target.closest('[data-reviews-prev]');
    var reviewsNext = e.target.closest('[data-reviews-next]');

    if (reviewsPrev) {
      var track = document.querySelector('[data-reviews-track]');
      if (track) {
        var card = track.querySelector('.review-card');
        var scrollAmount = card ? card.offsetWidth + 20 : 320;
        track.scrollBy({ left: -scrollAmount * 2, behavior: 'smooth' });
      }
    }

    if (reviewsNext) {
      var track = document.querySelector('[data-reviews-track]');
      if (track) {
        var card = track.querySelector('.review-card');
        var scrollAmount = card ? card.offsetWidth + 20 : 320;
        track.scrollBy({ left: scrollAmount * 2, behavior: 'smooth' });
      }
    }
  });

  // ---- Customer Creations Carousel Navigation ----
  document.addEventListener('click', function (e) {
    var ccPrev = e.target.closest('[data-cc-prev]');
    var ccNext = e.target.closest('[data-cc-next]');

    if (ccPrev) {
      var track = document.querySelector('[data-cc-track]');
      if (track) {
        var card = track.querySelector('.creation-card');
        var scrollAmount = card ? card.offsetWidth + 16 : 200;
        track.scrollBy({ left: -scrollAmount * 2, behavior: 'smooth' });
      }
    }

    if (ccNext) {
      var track = document.querySelector('[data-cc-track]');
      if (track) {
        var card = track.querySelector('.creation-card');
        var scrollAmount = card ? card.offsetWidth + 16 : 200;
        track.scrollBy({ left: scrollAmount * 2, behavior: 'smooth' });
      }
    }
  });

  // ---- Product Tabs (Size & Specs / Description) ----
  document.querySelectorAll('[data-tab-target]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.getAttribute('data-tab-target');
      var tabsContainer = this.closest('.product-tabs');
      if (!tabsContainer) return;

      // Deactivate all tabs and panels
      tabsContainer.querySelectorAll('[data-tab-target]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      tabsContainer.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.classList.remove('is-active');
      });

      // Activate clicked tab and matching panel
      this.classList.add('is-active');
      var panel = tabsContainer.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

})();
